// extracted by mini-css-extract-plugin
module.exports = {"color":"_1mj7g","dropdown":"_3Sftb"};